import _ from "lodash";
import { objectToQueryString } from "_helpers";
import { BillingSummaryBuilder } from "./objects/BillingSummaryBuilder";
import moment from "moment-timezone";

export const PRODUCT_SKU_COLUMN_MAP = {
  TEAMS: "teams",
  PROACTIVE_SOCIAL: "proactiveSocial",
  SOCIAL_MODERATION: "socialModeration",
  UNKNOWN: "unknown",
};

export const VIEW_TYPES = [
  { id: "amountCharged", name: "Amount Charged" },
  { id: "rowCount", name: "Row Count" },
];

export const transformBillingRows = (
  billingsList,
  metricKey
) => {
  const organizationMapping = {};

  billingsList.forEach((item) => {
    const organizationName = _.get(item, "organizationName", "-");
    const productSku = _.get(item, "productSku");
    const metricValue = Number(_.get(item, metricKey, 0)) || 0;
    const columnKey = PRODUCT_SKU_COLUMN_MAP[productSku] || "unknown";

    if (!organizationMapping[organizationName]) {
      organizationMapping[organizationName] = {
        organizationName,
        teams: 0,
        proactiveSocial: 0,
        socialModeration: 0,
        unknown: 0,
      };
    }

    organizationMapping[organizationName][columnKey] += metricValue;
  });

  return Object.values(organizationMapping).map((org) => {
    const builder = new BillingSummaryBuilder()
      .setOrganizationName(org.organizationName)
      .setTeams(org.teams)
      .setProactiveSocial(org.proactiveSocial)
      .setSocialModeration(org.socialModeration)
      .setUnknown(org.unknown);

    const row = builder.build();
    return {
      ...row,
      total:
        (row.teams || 0) +
        (row.proactiveSocial || 0) +
        (row.socialModeration || 0) +
        (row.unknown || 0),
    };
  });
};

export const buildBillingBreakdownUrl = (organizationName, range = {}) => {
  const queryString = objectToQueryString({
    startDate:  moment(range?.startDate).utc().format("YYYY-MM-DD HH:mm:ss"),
    endDate:  moment(range?.endDate).utc().format("YYYY-MM-DD HH:mm:ss"),
  });

  return `/billings/${organizationName}?${queryString}`;
};

export const calculateProductTotals = (rows = []) => {
  const initialTotals = Object.values(PRODUCT_SKU_COLUMN_MAP).reduce(
    (acc, key) => ({ ...acc, [key]: 0 }),
    { total: 0 }
  );

  return rows.reduce((totals, row) => {
    Object.values(PRODUCT_SKU_COLUMN_MAP).forEach((key) => {
      totals[key] += Number(row[key] || 0);
    });

    totals.total += Number(row.total || 0);
    return totals;
  }, initialTotals);
};
